import { withClientOnly } from 'lib/platform/withClientOnly';
import { useTranslation } from 'react-i18next';

import { LoaderIcon } from '@icons';
import { setupForDark } from '@theme';
import classNames from 'classnames';

interface LoaderProps extends React.HTMLAttributes<HTMLDivElement> {
  text?: string;
}
function Loader({ text = '', ...props }: LoaderProps) {
  const { t } = useTranslation();

  return (
    <div
      {...props}
      className={classNames(
        'w-full h-full',
        setupForDark('bg-page text-primary'),
        'flex flex-row items-center justify-center',
        'H6 gap-xs'
      )}
    >
      <LoaderIcon size={24} />
      {text || t('general.loading')}
    </div>
  );
}

export default withClientOnly(Loader);
